import * as React from 'react';

import type { IconProps } from './types';

export const TextBold = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <g clipPath="url(#clip0_300_1053)">
        <path
          d="M5.2497 11.375C4.68773 11.375 4.12576 11.3553 3.56378 11.3158C3.01167 11.2863 2.43491 11.2074 1.8335 11.0792V1.1412C2.30674 1.05246 2.82434 0.98838 3.38632 0.948944C3.94829 0.899648 4.47083 0.875 4.95393 0.875C5.60463 0.875 6.20111 0.924296 6.74337 1.02289C7.29548 1.11162 7.76872 1.26937 8.16309 1.49613C8.55746 1.72289 8.86309 2.02359 9.08 2.39824C9.30676 2.76303 9.42014 3.21655 9.42014 3.7588C9.42014 4.57711 9.02577 5.22289 8.23704 5.69613C8.88774 5.94261 9.33141 6.27782 9.56803 6.70176C9.80465 7.12571 9.92296 7.60387 9.92296 8.13627C9.92296 9.21092 9.52859 10.0194 8.73985 10.5616C7.96098 11.1039 6.7976 11.375 5.2497 11.375ZM4.08139 6.7757V9.42289C4.249 9.44261 4.43139 9.4574 4.62857 9.46726C4.82576 9.47711 5.04266 9.48204 5.27928 9.48204C5.96942 9.48204 6.52647 9.38345 6.95041 9.18627C7.37436 8.98909 7.58633 8.6243 7.58633 8.0919C7.58633 7.61866 7.40886 7.28345 7.05393 7.08627C6.699 6.87923 6.19126 6.7757 5.53069 6.7757H4.08139ZM4.08139 5.01585H5.20534C5.9152 5.01585 6.42295 4.92711 6.72858 4.74965C7.03422 4.56232 7.18703 4.26655 7.18703 3.86232C7.18703 3.44824 7.02929 3.15739 6.71379 2.98979C6.3983 2.82218 5.93492 2.73838 5.32365 2.73838C5.12646 2.73838 4.91449 2.74331 4.68773 2.75317C4.46097 2.75317 4.25886 2.76303 4.08139 2.78275V5.01585Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_300_1053">
          <rect width="11.6667" height="11.6667" fill="white" transform="translate(0.166748 0.166748)" />
        </clipPath>
      </defs>
    </svg>
  )
);

export default TextBold;
